module.exports = __webpack_public_path__ + "4f95a9b5c237cec89210aa9a24dc655e.pdf";